import { useAtom } from 'jotai';
import { useStore } from 'jotai/react';
import { useEffect } from 'react';
import { isPanningAtom, stageModeAtom, stageRefAtom } from '@/store/boardAtoms';
/**
 * Хук для управления курсором на Stage в зависимости от режима и состояния паннинга
 *
 * Логика:
 * - В режиме "рука" (move) - курсор "grab" (рука открыта)
 * - При активном паннинге - курсор "grabbing" (рука сжата)
 * - В других режимах - курсор "default"
 */
export const useStageCursor = () => {
    const store = useStore();
    const [stageMode] = useAtom(stageModeAtom);
    const [isPanning] = useAtom(isPanningAtom);
    useEffect(() => {
        const stage = store.get(stageRefAtom);
        if (!stage)
            return;
        const container = stage.container();
        if (!container)
            return;
        // Если активен режим "рука" или идет паннинг - устанавливаем курсор "рука"
        if (stageMode === 'move' || isPanning) {
            if (isPanning) {
                // При активном паннинге - курсор "grabbing" (рука сжата)
                container.style.cursor = 'grabbing';
            }
            else {
                // В режиме "рука" без активного паннинга - курсор "grab" (рука открыта)
                container.style.cursor = 'grab';
            }
        }
        else if (stageMode === 'ruler') {
            // В режиме линейки - курсор crosshair
            container.style.cursor = 'crosshair';
        }
        else {
            // В других режимах - обычный курсор
            container.style.cursor = 'default';
        }
    }, [stageMode, isPanning, store]);
};
